// Board.tsx
import React from 'react';
import styles from './styles.module.scss';

type Props = {
  wrapperClass?: string;
  children?: React.ReactNode;
  NOMORECORNERS?: boolean;
};

export const Board = React.forwardRef<HTMLDivElement, Props>(({ wrapperClass, children, NOMORECORNERS }, ref) => {
  return (
    <div className={`${styles.wrapper} ${wrapperClass}`}>
      <div className={styles.border}>
        {/* aqui encaminhamos o ref para a innerBoard */}
        <div className={styles.innerBoard} ref={ref}>
          {children}
        </div>
      </div>

      {!NOMORECORNERS && (
        <>
          <div className={styles.cornerTop}>
            <div className={`${styles.corner} ${styles.cornerLeft}`} />
            <div className={`${styles.corner} ${styles.cornerRight}`} />
          </div>
          <div className={styles.cornerBottom}>
            <div className={`${styles.corner} ${styles.cornerLeft}`} />
            <div className={`${styles.corner} ${styles.cornerRight}`} />
          </div>
        </>
      )}
    </div>
  );
});

Board.displayName = 'Board';
